
import { gapi } from "gapi-script";

const getClientID = (resultHandler, enqueueSnackbar) => {
  let googleCredential = "/api/googleCredential";
  if (process.env.NODE_ENV !== "production") {
    googleCredential = "http://localhost:7071/api/googleCredential";
  }
  fetch(googleCredential, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      response
        .text()
        .then((text) => {
          throw Error(response.statusText + ": " + text);
        })
        .catch((error) => enqueueSnackbar(error.message, { variant: "error" }));
    } else {
      response.json().then((result) => {
        initGoogleClient(result, resultHandler);
      });
    }
  });
};
const getTokenInfo = (resultHandler) => {
  let googleCredential = "/api/accessToken";
  if (process.env.NODE_ENV !== "production") {
    googleCredential = "https://evasandbox.azurewebsites.net/api/accessToken";
  }
  fetch(googleCredential, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      response
        .text()
        .then((text) => {
          throw Error(response.statusText + ": " + text);
        })
        .catch();
    } else {
      response.json().then((result) => {
        gapi.client.setToken({ access_token: result.accessToken });
        resultHandler();
      });
    }
  });
};
const initGoogleClient = (clientInfo, resultHandler) => {
  function start() {
    gapi.client
      .init({
        apiKey: clientInfo.apiKey,
        clientId: clientInfo.clientID,
        scope: clientInfo.scope,
        discoveryDocs: [
          "https://sheets.googleapis.com/$discovery/rest?version=v4",
          "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
        ],
      })
      .then(
        () => getTokenInfo(resultHandler),
        (error) => {
          console.error("GAPI Client Initialization Failed:", error);
        }
      );
  }

  gapi.load("client:auth2", start);
  
};

function loadGoogleClient(resultHandler, snackbar) {
  const enqueueSnackbar = snackbar;
  if (process.env.NODE_ENV === "production") {
    getClientID(resultHandler, enqueueSnackbar);
  }
  return null;
}

export default loadGoogleClient;
